import { useQuery } from "@apollo/client/react";
import type { InvoiceModel } from "../../../models/InvoiceModels";
import GET_INVOICE_DUPLICATES from "../../queries/invoices/getInvoiceDuplicates";

export const useInvoiceDuplicates = (
  clientIdentifier: string,
  invoiceId: string,
) => {
  const { data, error, loading, refetch } = useQuery<{
    invoice: InvoiceModel;
  }>(GET_INVOICE_DUPLICATES, {
    variables: {
      clientIdentifier: clientIdentifier,
      invoiceId: invoiceId,
    },
    errorPolicy: "all",
  });
  return { invoice: data?.invoice, error, loading, refetch };
};
